import React from 'react';
import classes from './AccordionItem.module.css';
import { Accordion } from 'react-bootstrap';
import clsx from 'clsx';
import { forwardRef } from 'react';
const AccordionItem = ({ eventKey = 0, header, className, children }) => {
  return (
    <Accordion.Item eventKey={eventKey} className={clsx(classes.accordionItem, className)}>
      <Accordion.Header>{header}</Accordion.Header>
      <Accordion.Body>{children}</Accordion.Body>
    </Accordion.Item>
  );
};

export default AccordionItem;
